import React, { useState, useEffect} from 'react'

import { 
    Layout,
    Col, 
    Row,
    Space,
    Select,
    Input,
    DatePicker,
} from 'antd';
import dayjs from 'dayjs';
import Navbar from '../../Components/Navbar/Navbar'
import AntDTable from '../../Components/Table/AntDTable';
import BtnExcel from '../../Components/BtnExcel';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { formatAmount, getTodayDateISO } from '../../Utils/Common';

const { Search } = Input;
const { RangePicker } = DatePicker;

const MonthlyPayment = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [exportLoading, setExportLoading] = useState(false);
  const [pageSize, setPageSize] = useState('');
  const [excelData, setExcelData] = useState([])
  const [monthlyPayment, setMonthlyPayment] = useState([])
  const [totalAmount, setTotalAmount] = useState(0);
  const startDate = dayjs().startOf('month');
  const endDate = dayjs().endOf('month');

  const [filterConfig, setFilterConfig] = useState({
    start_date: dayjs(startDate).format('YYYY-MM-DD'),
    end_date: dayjs(endDate).format('YYYY-MM-DD'),
    type: '',
    search: '',
    page: 1,
  })

  async function fetchPaymentData() {
    setIsLoading(true);
    const response = await UseGetRequest("tenants/monthly_payments", filterConfig);
    if (response.data) {
      const month = response?.data?.data?.map((data) => ({
        billing_no: data.billing_no,
        tenant_name: data.tenant_name,
        basic_rent: formatAmount(data.basic_rent),
        parking_rent: formatAmount(data.parking_rent),
        cusa: formatAmount(data.cusa),
        electricity: formatAmount(data.electricity),
        gas: formatAmount(data.gas),
        water: formatAmount(data.water),
        pestcon: formatAmount(data.pestcon),
        refundable: data.refundable && formatAmount(data.refundable),
        total: formatAmount( data.total),
      }))

      setMonthlyPayment(month);
      setTotalAmount(response?.data?.total)
      setPageSize(response?.data?.size)
    } else {
      setTotalAmount(0)
      setMonthlyPayment([])
      setPageSize('')
    }

    setIsLoading(false);
  }

  async function fetchExportData() {
    setExportLoading(true)
    const response = await UseGetRequest("tenants/monthly_payments", 
      {
        start_date: filterConfig.start_date,
        end_date: filterConfig.end_date,
        type: filterConfig.type,
        search: filterConfig.search,
      }
    );
    if (response?.data) {
      const data = response?.data?.data?.map((data) => ({
        tenant_name: data.tenant_name,
        basic_rent: data.basic_rent,
        parking_rent: data.parking_rent,
        cusa: data.cusa,
        electricity: data.electricity,
        gas: data.gas,
        water: data.water,
        pestcon: data.pestcon,
        refundable: data.refundable && formatAmount(data.refundable),
        total: data.total,
      }))

      setExcelData(data)
      setExportLoading(false);
    } else {
      setExcelData([])
      setExportLoading(false);
    }
  }

  const onSearchType = (e) => {
    setFilterConfig((prev) => (
      { 
        ...prev,
        type: e || '',
        page: 1,
      }
    ));
  }; 

  const handleSearchChange = (e) => {
    setFilterConfig((prev) => (
      {
        ...prev,
        search: e || '',
        page: 1,
      }
    ));
  };

  const handleEmpty = (e) => {
    if(e.target.value === ''){
      setFilterConfig((prev) => (
        {
          ...prev,
          search: e.target.value || '',
          page: 1,
        }
      ));
    }
  };

  const onSearchDate = (e) => {
    if(e){
     setFilterConfig((prev) => (
       {
         ...prev,
         start_date: e[0].format("YYYY-MM-DD"),
         end_date: e[1].format("YYYY-MM-DD"),
         page: 1,
       }
     ));
    } else {
      setFilterConfig((prev) => (
        {
          ...prev,
          start_date: '',
          end_date: '',
          page: 1,
        }
      ));
    }
  };

  const handleTableChange = (pagination) => {
    setFilterConfig((prev) => ({
      ...prev,
      page: parseInt(pagination.current),
      page_size: pagination.pageSize
      // total_records_per_page: pagination.pageSize,
    }));
  };

  useEffect(() => {
    fetchPaymentData();
    fetchExportData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterConfig]);

  return (
    <Layout className='page'>
      <Navbar navKey={'monthly_payment_nav'}/>
      <Layout className='content-container'>
        <Row className='custom-padding responsive-inline responsive-tab-inline'>
          <Col span={12} className='header-container'>
            MONTHLY PAYMENT
          </Col>
          <Col span={12} className='mt-2 responsive-tab-width' align='end'>
            <Space className='responsive-inline'>
              <BtnExcel
                label={"Export to Excel"}
                size={"sm"}
                excelData={excelData}
                xlsxHeaders={[
                  "Tenant/Owner Name",
                  "Unit Rent",
                  "Parking Rent",
                  "Cusa",
                  "Electricity",
                  "Gas",
                  "Water",
                  "Others",
                  "Sec Deposit",
                  "Total",
                ]}
                handleData={fetchExportData}
                isClicked={exportLoading}
                fileName={`Monthly_Payment_${getTodayDateISO()}.xlsx`}
              />
            </Space>
          </Col>
        </Row>
        <Row>
          <Space className='responsive-inline excel-row'>
            <Search
              placeholder="Search..."
              size='medium'
              onSearch={(e)=>handleSearchChange(e)}
              onChange={(e)=>handleEmpty(e)}
              className='responsive-header-input'
            />    
            
            <Select
              placeholder="All Type"
              onChange={(e)=>onSearchType(e)}
              placement='bottomLeft'
              className='select-field responsive-header-input'
              align='left'
              options={[
                {
                  value: '',
                  label: 'All Type',
                },
                {
                  value: 'owner',
                  label: 'Owner',
                },
                {
                  value: 'tenant',
                  label: 'Tenant',
                },
              ]}
            />    

            <RangePicker 
              renderExtraFooter={() => 'extra footer'}
              className='responsive-header-input'
              onChange={(e)=>onSearchDate(e)}
              defaultValue={[
                dayjs(startDate, 'YYYY/MM/DD'),
                dayjs(endDate, 'YYYY/MM/DD')
              ]}
            />    
          </Space>
        </Row>
        <Row gutter={[16, 16]} className='me-4'>
          <Col span={12}>
          
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} className='amount-total' align='right'>
            Total Amount: {formatAmount(totalAmount)}
          </Col>
        </Row>
        <Row className='page-content'>
          <Col span={24} className='responsive-overflow-auto'>
            <AntDTable
              tableHeaders={[
                "Tenant/Owner Name",
                "Unit Rent",
                "Parking Rent",
                "Cusa",
                "Electricity",
                "Gas",
                "Water",
                "Others",
                "Sec Deposit",
                "Total",
              ]}
              headerSelector={[
                "tenant_name",
                "basic_rent",
                "parking_rent",
                "cusa",
                "electricity",
                "gas",
                "water",
                "pestcon",
                "refundable",
                "total",
              ]}
              tableData={monthlyPayment}
              withAction={false}
              loading={isLoading}
              tablePages={10}
              handleTableChange={handleTableChange}
              filterConfig={filterConfig}
              totalSize={pageSize}
              isSearch={true}
            />
          </Col>
        </Row>
      </Layout>
    </Layout>
  )
}

export default MonthlyPayment
